/*
 * 查询可开票记录
 */
import Vue from 'vue'

const vm = new Vue()
// 查询可开票记录
export function queryBilling (params) {
  return vm.$http.post('i/api/electronicInvoice/queryBilling', params)
}
// 申请开票
export function applyBilling (params) {
  return vm.$http.post('i/api/electronicInvoice/applyBilling', params)
}
// 发票开票信息查询接口
export function getData (params) {
  return vm.$http.post('r/api?sysName=CCB&apiName=CM-CXFPINFO', params)
}
